import React from 'react'
import { bool, func } from 'prop-types'

import soundStaticSVG from '../../assets/sound-static.svg'
import soundSVG from '../../assets/sound.svg'

import styles from './index.module.css'

export default function AudioPlayer(props) {
  const { playing, handleAudioClick } = props

  return (
    <div className={styles.cntr} onClick={handleAudioClick}>
      <img src={playing ? soundSVG : soundStaticSVG} alt='' />
    </div>
  )
}

AudioPlayer.propTypes = {
  playing: bool,
  handleAudioClick: func
}
